import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  AVG_ITEM_SALE,
  BASE_URL,
  IS_PY_GRAPHS,
  REPORTS_BASE_URL,
  REPORTS_AVG_ITEM_SALE,
} from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";

const initialState = {
  loading: true,
  avgItemSaleData: [],
  totalAvgItemSale: 0,
  previousWeekAvgItemSale: 0,
  error: "",
  isCancel: false,
};
let controller = null;

export const getAvgItemSale = createAsyncThunk(
  "avgItemSaleChart/getAvgItemSale.",
  async (data, { rejectWithValue }) => {
    // return []; // set cors error for tetsing as this call is no more in backend
    const { userTypeData } = useAuthDetails();
    if (controller) {
      controller.abort();
    }

    // Create a new AbortController instance for the current request
    controller = new AbortController();
    try {
      const { token, ...otherUserData } = userTypeData;

      const requestData = { ...(data || {}) };
      const activeType =
        requestData?.activeType || requestData?.view_by || requestData?.date_type;
      const isWeek = String(activeType || "").toLowerCase() === "week";

      const dateInYYYYMMDD = (date) => {
        const year = date?.getFullYear();
        const month = String(date?.getMonth() + 1)?.padStart(2, "0");
        const day = String(date?.getDate())?.padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      if (isWeek) {
        const minusOneDay = (dateStr) => {
          const date = new Date(dateStr);
          date.setDate(date.getDate());
          return date.toISOString().split("T")[0]; // YYYY-MM-DD
        };
        requestData["date_range"] = `${minusOneDay(requestData.start_date)}_${minusOneDay(requestData.end_date)}`;
      }
      const apiUrl =
        IS_PY_GRAPHS === true || IS_PY_GRAPHS === "true"
          ? REPORTS_BASE_URL + REPORTS_AVG_ITEM_SALE
          : BASE_URL + AVG_ITEM_SALE;
      const response = await axios.post(
        apiUrl,
        { ...requestData, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );

      let total_revenue_data = 0;

      if (isWeek) {
        const resultArray = response?.data?.filter_revenue_data || [];
        console.log("resultArray", resultArray);
        let total = 0;
        if (Array.isArray(resultArray)) {
          resultArray.forEach((row) => {
            total += +row?.total_revenue || 0;
          });
        }

        // const filter_revenue_data = dateKeys.map((d) => ({
        //   total_revenue: parseFloat((total || 0).toFixed(2)),
        //   sale_count: 0,
        // }));
        total_revenue_data = total;
        console.log("total_revenue_data", total_revenue_data);
        return {
          ...response?.data,
          sale_count_data: resultArray,
          total_revenue_data: total_revenue_data,
        };
      }
      total_revenue_data =
        response?.data?.total_revenue_data ?? response?.data?.filter_revenue_data ?? 0;

      return {
        ...response?.data,
        total_revenue_data: total_revenue_data,
      };

    } catch (error) {
      if (axios.isCancel(error) || error.name === "CanceledError") {
        return rejectWithValue({ isCanceled: true }); // Mark as canceled
      }
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const avgItemSaleChartSlice = createSlice({
  name: "avgItemSaleChart",
  initialState,
  reducers: {
    clearAvgItemSaleChart: (state, action) => {
      state.loading = true;
      state.avgItemSaleData = [];
      state.totalAvgItemSale = 0;
      state.previousWeekAvgItemSale = 0;
      state.error = "";
      state.isCancel = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAvgItemSale.pending, (state) => {
      state.loading = true;
      state.isCancel = false;
    });
    builder.addCase(getAvgItemSale.fulfilled, (state, action) => {
      state.loading = false;
      state.avgItemSaleData = action.payload?.filter_revenue_data || [];
      state.totalAvgItemSale = action.payload?.total_revenue_data || 0;
      state.previousWeekAvgItemSale = action.payload?.previous_avg || 0;
      state.error = "";
      state.isCancel = false;
    });
    builder.addCase(getAvgItemSale.rejected, (state, action) => {
      state.loading = false;
      state.avgItemSaleData = [];
      state.totalAvgItemSale = 0;
      state.previousWeekAvgItemSale = 0;
      state.error = action.error.message;
      state.isCancel = action.payload.isCanceled;
    });
  },
});

export const { clearAvgItemSaleChart } = avgItemSaleChartSlice.actions;
export default avgItemSaleChartSlice.reducer;
